import i18n from '@/api/i18n/i18n';

const actionDict = {
  0: i18n.t('pages.actionDict.noDescription'),
  3: i18n.t('pages.actionDict.computerStartup'),
  4: i18n.t('pages.actionDict.computerShutdown'),
  23: i18n.t('pages.actionDict.downtimeStart'),
  24: i18n.t('pages.actionDict.downtimeEnd'),
  25: i18n.t('pages.actionDict.userSessionStart'),
  26: i18n.t('pages.actionDict.userSessionEnd'),
  27: i18n.t('pages.actionDict.screenSaverStart'),
  28: i18n.t('pages.actionDict.screenSaverEnd'),
  29: i18n.t('pages.actionDict.workstationLock'),
  30: i18n.t('pages.actionDict.workstationUnlock'),
};

export const action = (val) => actionDict[val];
